import { useNavigate } from 'react-router-dom';

import { HomeView } from './HomeView';
import { NavigationPage, NAVIGATION_ITEMS } from '@src/constants/navigation';

export const HomeContainer = () => {
  const navigate = useNavigate();

  const handleNavigateTo = (page: NavigationPage) => {
    const item = NAVIGATION_ITEMS.find((item) => item.id === page);
    if (item) {
      navigate(item.route);
    }
  };

  return <HomeView onNavigateTo={handleNavigateTo} />;
};
